import Box from '@mui/material/Box';
import CodeIcon from '@mui/icons-material/Code';
import Fab from '@mui/material/Fab';
import React, {useRef} from 'react';
import ReactDOM from 'react-dom';
import {func, number} from 'prop-types';

const SliderLine = React.forwardRef((props, ref) => (
  <Box
    ref={ref}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100%',
      position: 'absolute',
      top: 0,
      zIndex: 0,
      transform: 'translateX(-50%)',
      '&:before,&:after': {
        content: '""',
        display: 'block',
        flexGrow: 1,
        width: 3,
        boxShadow: 1,
        backgroundColor: 'grey.100',
        position: 'relative',
        zIndex: 1,
      },
    }}
    left="50%" // keep outside of sx so that it can be overriden
    {...props}
  />
));

const CompareSlider = ({mapWidth, position, onChange}) => {
  const containerRef = useRef();

  const onDrag = event => {
    const clientX = event.clientX;
    const node = ReactDOM.findDOMNode(containerRef.current);
    if (node) {
      const rect = node.offsetParent.getBoundingClientRect();
      const position = (clientX - rect.left) / rect.width;
      const fraction = Math.max(0, Math.min(1, position));
      onChange(fraction);
    }
  };

  const onDragEnd = () => {
    document.removeEventListener('mousemove', onDrag);
    document.removeEventListener('mouseup', onDragEnd);
  };

  const onDragStart = () => {
    document.addEventListener('mousemove', onDrag);
    document.addEventListener('mouseup', onDragEnd);
  };

  return (
    <SliderLine ref={containerRef} left={mapWidth * position}>
      <Fab
        size="small"
        color="primary"
        disableRipple
        // onMouseMove={onDrag}
        onMouseDown={onDragStart}
        sx={{
          border: '2px solid',
          borderColor: 'grey.200',
          pointerEvents: 'all',
        }}
        data-qe="compare-tool-slider-handle"
      >
        <CodeIcon fontSize="small" />
      </Fab>
    </SliderLine>
  );
};

CompareSlider.propTypes = {
  mapWidth: number,
  onChange: func,
  position: number,
};

export default CompareSlider;
